<dx-popup
  [visible]="showModal"
  [showTitle]="true"
  [title]="'QR-CODE.SCAN-QR-CODE' | translate"
  [width]="'90%'"
  [maxWidth]="500"
  [height]="'auto'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHidden)="close()"
>
  <div>
    <img [src]="qrCodeImageUrl" alt="QR Code" class="w-100 h-100"/>
    <br>
    <div class="actions">
      <dx-button
        icon="download"
        [text]="'COMMON.DOWNLOAD' | translate"
        color="primary"
        (onClick)="downloadPhoto()"
      ></dx-button>
      <dx-button
        icon="copy"
        [text]="'QR-CODE.SAVE-TO-CLIPBOARD' | translate"
        color="primary"
        (onClick)="copyQRCodeToClipboard()"
      ></dx-button>
    </div>
    <div *ngIf="showCopyButton">
      <hr>
      <div class="qrcode-link-container">
        <span class="qrcode-text">
          {{ copyButtonText }}
        </span>

        <div class="copy-button">
          <dx-button
            type="default"
            icon="copy"
            (click)="copyUrlToClipboard()"
          ></dx-button>
        </div>
      </div>
    </div>
  </div>
</dx-popup>